import { defineMessages } from "react-intl";

export default defineMessages({
  activateAppTitle: {
    id: "YHNozE",
    defaultMessage: "Activate App",
    description: "dialog header",
  },
  activateApp: {
    id: "Q47ovw",
    defaultMessage:
      "Are you sure you want to activate this app? Activating will start gathering events.",
    description: "activate app",
  },
  activateNamedApp: {
    id: "JbUg2b",
    defaultMessage:
      "Are you sure you want to activate {name}? Activating will start gathering events.",
    description: "activate app",
  },
});
